<template>
  <div v-show="isShow" class="tool-mask" :style="maskStyle" ref="toolMask">
    <div
      class="tool-mask__part tool-mask__part--left"
      :style="partLeftStyle"
      @mousedown.stop="onClickMask()"
    ></div>
    <div
      class="tool-mask__part tool-mask__part--top"
      :style="partTopStyle"
      @mousedown.stop="onClickMask()"
    ></div>
    <div
      class="tool-mask__part tool-mask__part--bottom"
      :style="partBottomStyle"
      @mousedown.stop="onClickMask()"
    ></div>
    <div
      class="tool-mask__part tool-mask__part--right"
      :style="partRightStyle"
      @mousedown.stop="onClickMask()"
    ></div>
    <div class="tool-mask__context" ref="contextRef" @mousedown.stop="onClickMask()">
      <div
        class="tool-mask__clone-wrapper"
        v-show="isCloneShow"
        @mousedown.stop="onClickMask()"
        ref="cloneWrapperRef"
      ></div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  data() {
    return {
      isShow: false,
      padding: {},
      spriteContentClone: null,
      editorEl: null,
      partLeftStyle: {},
      partTopStyle: {},
      partBottomStyle: {},
      partRightStyle: {},
      parentElement: null,
      maskStyle: {},
      exportElements: [],
      isRNavOpen: false,
      rightNavStyle: null,
      isCloneShow: false,
      wSize: {
        width: document.body.clientWidth,
        height: window.innerHeight,
        scale: "",
        ready: false
      },
      tid: null,
      sprite: null,
      cache: {
        wInnerWidth: 0,
        wInnerHeight: 0
      },
      scrollContainer: null,
      isToolWidthChanged: false
    };
  },
  computed: {
    ...mapGetters([
      "TOOL",
      "SelectScenes_Msg",
      "SelectSprites_Msg",
      "Window_Size",
      "Tool_Size",
      "MaterialPane_Size",
      "SetPanel_Size",
      "TopNav_Size",
      "TimeLine_size",
      "SpriteOperation",
      "S_GlobalSearch",
      "ShowTemplateMaterialLibDialog"
    ])
  },
  watch: {
    SpriteOperation(val) {
      this.toggleToolMask({
        isShow: val === "swap"
      });
      // let el = document.querySelector('#app>.popups-z');
      // if (!el) {
      //   return;
      // }
      // if (val === 'swap') {
      //   el.style.zIndex = 15;
      // } else {
      //   el.style.zIndex = 25;
      // }
    },
    "TOOL.option.width": function(val) {
      this.isToolWidthChanged = true;
      this.resizeMask();
    },
    "Window_Size.height": function(val) {
      this.resizeMask();
    },
    SetPanel_Size: {
      handler(val, old) {
        // if (val.width > old.width) {
        setTimeout(() => {
          // if (this.isToolWidthChanged) {
          //   this.isToolWidthChanged = false;
          //   return;
          // }

          this.resizeMask();
        }, 1000);
        // }
      },
      deep: true
    },
    ShowTemplateMaterialLibDialog(val) {
      if (!val) {
        this.$store.commit("save_BgOperation", "add");
      }
    }
  },

  created() {
    // this.$bus.on('toggleToolMask', this.toggleToolMask);
    this.$bus.on("spriteSwapped_vue", this.onSpriteSwapped);
    this.scrollContainer = document.body.querySelector(".scroll-visible");
  },
  mounted() {
    this.parentElement = this.$el.parentElement;
  },
  methods: {
    append(el) {
      // this.$el.appendChild(el);
      this.isCloneShow = true;
    },
    removeChild(el) {
      // this.$el.removeChild(el);
      this.isCloneShow = false;
      this.$refs.cloneWrapperRef.innerHTML = "";
    },
    toggleToolMask({ isShow }) {
      let sprite = this.SelectSprites_Msg[0];
      this.scrollContainer = document.body.querySelector(".scroll-visible");
      this.isShow = isShow;
      if (this.isShow) {
        this.sprite = sprite;

        // 显示遮罩层时，清空右侧栏搜索
        if (this.S_GlobalSearch) {
          this.$store.commit("save_SearchClose", false);
        }

        this.showMask();
        this.$bus.emit("FeaturesPop_close_vue", {
          type: 3
        });
        // this.TOOL.spriteBeforeSwap = sprite;
        this.$store.commit("save_SpriteBeforeSwap", sprite);
      } else {
        this.unappendCloneContext();
        this.unappendToOutSide();
        this.removeChild();
        this.setSpriteVisibility(this.isShow);
        this.$store.commit("save_SpriteBeforeSwap", null);
        this.sprite = null;
        this.isToolWidthChanged = false;
      }
    },
    showMask() {
      this.cloneSpriteContent();
      // this.pad();
      this.setMaskStyle();

      this.$nextTick(this.setPartStyle());

      this.appendToOutSide();
      this.append();
      this.setSpriteVisibility(this.isShow);
      // let dur = this.getTransitionDuration();
      this.TOOL.selectSprite([this.sprite]);
      // setTimeout(() => { 
        // if (this.sprite !== this.SelectSprites_Msg[0]) {
        // }
      // }, 500);
    },
    setSpriteVisibility(isMaskShow) {
      let flag = isMaskShow;
      let sprite = this.sprite || this.SelectSprites_Msg[0];
      // sprite.ele.css({'visibility': flag ? 'hidden' : 'visible'});
      if (flag) {
        this.memoZ = sprite.ele.css("zIndex");
        $(".set-pathAnim").css({ opacity: 0 });
      } else {
        // let currSprite = sprite;
        // const sprites = this.TOOL.selectedScenes.sprites;
        $(".set-pathAnim").css({ opacity: 1 });
      }
      sprite.ele.css({ zIndex: flag ? "-1" : this.memoZ });
      sprite.opHelper.el.css({ visibility: flag ? "hidden" : "visible" });
      // hide spriteBtn
      this.$bus.emit("settingPopup.toggle", flag);
    },
    cloneSpriteContent() {
      const vm = this;
      let { sprite } = vm;
      // this.spriteContentClone = this.SelectSprites_Msg[0].ele[0].cloneNode(true);
      let wrapper = this.$refs.cloneWrapperRef;
      if (wrapper.children.length) {
        return;
      }
      let rect = {};
      let { bool: isScrollActive } = this.isScrollActive(this.scrollContainer);
      if (isScrollActive) {
        rect = this.scrollContainer.getBoundingClientRect();
      } else {
        rect = this.TOOL.contentBody[0].getBoundingClientRect();
      }
      let context = this.$refs.contextRef;
      context.style.cssText = `position: absolute;
        z-index: 0;
        width: ${rect.width}px;
        height: ${rect.height}px;
        background-color: rgba(248, 248, 248, 0.75);
      `;
      context.style.top = rect.top + document.documentElement.scrollTop + "px";
      context.style.left =
        rect.left + document.documentElement.scrollLeft + "px";
      let currEl = sprite.ele[0];
      if (sprite.effect.pathAnim.target) {
        currEl = document.body.querySelector(".set-pathAnim>.current");
      }
      let spriteRect = currEl.getBoundingClientRect();
      let centerPoint = {
        x: spriteRect.left + spriteRect.width / 2,
        y: spriteRect.top + spriteRect.height / 2
      };
      let trueTL = {
        top: centerPoint.y - currEl.offsetHeight / 2,
        left: centerPoint.x - currEl.offsetWidth / 2
      };
      let clone = sprite.ele[0].cloneNode(true);
      // const $svg = $(clone).find('svg');
      // if ($svg.length) {
      //   const img = this.handleSVG($svg[0]);
      //   img.style.width = '100%';
      //   img.style.height = '100%';
      //   $svg.remove();
      //   $(clone).append(img);
      // }
      clone.style.display = "";
      let helperClone = sprite.opHelper.el[0].cloneNode(true);
      helperClone.style.display = "";

      wrapper.style.position = "absolute";
      wrapper.style.zIndex = "0"; // 层级比四周的透明遮罩小
      wrapper.style.transform = clone.style.transform;
      clone.style.transform = "";
      helperClone.style.transform = "";

      ["top", "left"].forEach(name => {
        // let sName = name === 'top' ? 'scrollTop' : 'scrollLeft';
        // let pName = name === 'top' ? 'positionTop' : 'positionLeft';
        wrapper.style[name] =
          trueTL[name] /* + document.documentElement[sName] */ -
          rect[name] +
          "px";
      });

      // clone.style.position = 'static';
      clone.style.position = "relative";
      clone.style.top = 0;
      clone.style.left = 0;
      clone.style.opacity = 1;
      clone.style.removeProperty("display");

      helperClone.style.top = "0px";
      helperClone.style.left = "0px";
      helperClone.style.border = "1px dashed #474261";
      helperClone.querySelector(".handle-point-ele").style.display = "block";
      helperClone.querySelector(".op-handle-spin").style.display = "none";
      helperClone.style.removeProperty("display");

      // let $v = $(clone).find('video');
      // if ($v[0]) {
      //   let u = this.$handleAssetsUrl(this.sprite.video.poster);
      //   u && $v.hide();
      //   u && $v.parent().append(`<img src="${u}"/>`);
      // }

      wrapper.appendChild(clone);
      wrapper.appendChild(helperClone);

      // this.pad(wrapper);
      let popupsEl = document.body.querySelector("#app>.popups-z");
      // popupsEl.appendChild(wrapper);
      popupsEl.appendChild(context);
      popupsEl.addEventListener("mousedown", function hdl() {
        popupsEl.removeEventListener("mousedown", hdl);
        vm.unappendCloneContext();
        vm.unappendToOutSide();
      });
    },
    unappendWrapper() {
      let wrapper = this.$refs.cloneWrapperRef;
      this.$el.appendChild(wrapper);
    },
    unappendCloneContext() {
      let context = this.$refs.contextRef;
      this.$el.appendChild(context);
    },
    getPadding(el) {
      let editorEl = this.TOOL.ele[0];
      let rect = (el || editorEl).getBoundingClientRect();
      return {
        top: this.TOOL.PfixTop - rect.top,
        left: this.TOOL.PfixLeft - rect.left
      };
    },
    pad(el) {
      let style = el.style;
      let _style = (this.sprite || this.SelectSprites_Msg[0]).ele[0].style;
      this.padding = this.getPadding(document.documentElement);

      style.top = parseFloat(_style.top) + this.padding.top + "px";
      style.left = parseFloat(_style.left) + this.padding.left + "px";
    },
    onClickMask() {
      this.closeMask();
    },
    closeMask() {
      this.$store.commit("save_SpriteOperation", "add");
    },
    setPartStyle() {
      // 编辑器画布尺寸数据
      let rect = {
        top: this.TOOL.PfixTop,
        left: this.TOOL.PfixLeft,
        width: this.TOOL.clientWidth,
        height: this.TOOL.clientHeight
      };

      let sRect = {};
      let { bool: isScrollActive } = this.isScrollActive(this.scrollContainer);
      if (isScrollActive) {
        sRect = JSON.parse(
          JSON.stringify(this.scrollContainer.getBoundingClientRect())
        );
        let docRect = document.documentElement.getBoundingClientRect();
        sRect.top = sRect.top - docRect.top;
        sRect.left = sRect.left - docRect.left;
        rect = sRect;
      }

      let commonStyle = {
        // position: 'fixed',
        position: "absolute",
        backgroundColor: "rgba(248, 248, 248, 0.75)",
        zIndex: 1,
        // transitionDuration: "0.3s"
      };
      this.partLeftStyle = {
        ...commonStyle,
        top: 0,
        left: rect.left - this.TOOL.fixLeft + 'px',
        width: this.TOOL.fixLeft + "px",
        height: this.Window_Size.height + "px"
      };
      this.partTopStyle = {
        ...commonStyle,
        top: 0,
        left: rect.left + "px",
        width: rect.width + "px",
        height: rect.top + "px"
      };
      this.partBottomStyle = {
        ...commonStyle,
        top: rect.top + rect.height + "px",
        left: rect.left + "px",
        width: rect.width + "px",
        height: this.Window_Size.height - rect.top - rect.height + "px"
      };
      this.partRightStyle = {
        ...commonStyle,
        top: 0,
        left: rect.left + rect.width + "px",
        width: this.TOOL.fixLeft + this.SetPanel_Size.width + "px",
        height: this.Window_Size.height + "px"
      };
    },
    appendToOutSide() {
      let arr = [...this.$el.children].slice(0, 4);
      this.exportElements = arr;
      // let tmp = document.createElement('div');
      // tmp.style.cssText = 'position: absolute; top: 0; left: 0; overflow: hidden';
      arr.forEach(el => {
        document.body.querySelector("#app>.popups-z").appendChild(el);
      });
      // document.body.querySelector('#app>.popups').appendChild(tmp);
    },
    unappendToOutSide() {
      this.exportElements.forEach(el => {
        this.$el.insertBefore(el, this.$refs.contextRef);
      });
    },
    setMaskStyle() {
      const vm = this;
      this.$nextTick(() => {
        const offsetParent = this.$refs.toolMask.offsetParent;
        this.maskStyle = {
          top: 0,
          left: 0,
          width: offsetParent.offsetWidth + "px",
          height: offsetParent.offsetHeight + "px"
        };
      });
    },
    onSpriteSwapped() {
      this.closeMask();
    },
    resizeMask() {
      if (this.SpriteOperation === "add") {
        return;
      }
      // let dur = this.getTransitionDuration();
      // this.$nextTick(() => {
      //   setTimeout(() => {
      //     this.baseResizeMask();
      //   }, 0);
      // });

      this.baseResizeMask();
    },
    baseResizeMask() {
      this.setSpriteVisibility(false);
      this.setMaskStyle();
      this.setPartStyle();
      this.unappendCloneContext();
      this.removeChild();
      this.cloneSpriteContent();
      this.append();
      this.setSpriteVisibility(true);
    },
    isScrollActive(scrollContainer) {
      let sy = scrollContainer.querySelector(".scroll-dragger.scroll-y");
      let sx = scrollContainer.querySelector(".scroll-dragger.scroll-x");
      return {
        bool:
          (sy && sy.style.display !== "none") ||
          (sx && sx.style.display !== "none"),
        sy,
        sx
      };
    },
    handleSVG(svgEl) {
      // svgEl.style.filter = '';
      var s = new XMLSerializer().serializeToString(svgEl);
      var encodedData = window.btoa(unescape(encodeURIComponent(s)));
      var img = new Image();
      var rect = svgEl.getBoundingClientRect();
      img.width = rect.width;
      img.height = rect.height;
      img.src = "data: image/svg+xml;base64, " + encodedData;
      return img;
    }
  }
};
</script>

<style lang="scss" scoped>
@import "../../style/transition";
.tool-mask {
  position: absolute;
  top: 0;
  left: 0;
  z-index: 125;
  width: 100%;
  height: 100%;
  background-color: rgba(248, 248, 248, 0);

  &__part {
    position: fixed;
    background-color: rgba(248, 248, 248, 0.75);
  }
}
</style>




// WEBPACK FOOTER //
// src/components/tool/mask.vue